import { renameDocument } from "../files/files.service";

/**
 * @returns {ThunkAction}
 */
 export function setDocument(document) {
    return (dispatch) => {
        dispatch({ 
            type: "RENAME_MODAL_SET_DOCUMENT", 
            document: document
         });
    }
}

/**
 * @returns {ThunkAction}
 */
 export function setUpdatedName(updatedName) {
    return (dispatch) => {
        dispatch({ 
            type: "RENAME_MODAL_SET_UPDATED_NAME", 
            updatedName: updatedName,
         });
    }
}

/**
 * @returns {ThunkAction}
 */
 export function reset() {
    return (dispatch) => {
        dispatch({ 
            type: "RENAME_MODAL_RESET",
         });
    }
}

/**
 * @returns {ThunkAction}
 */
 export function toggleRenameModal(display = true) {
    return (dispatch) => {
        dispatch({ 
            type: "RENAME_MODAL_TOGGLE_MODAL_DISPLAY", 
            showModal: display,
         });
    }
}

/**
 * @returns {ThunkAction}
 */
 export function toggleRenameConfirmModal(display = true) {
    return (dispatch) => {
        dispatch({ 
            type: "RENAME_MODAL_TOGGLE_CONFIRM_MODAL_DISPLAY", 
            showConfirmModal: display,
         });
    }
}

export const renameDocumentFromModal = (updatedName, force = 0) => {
    return (dispatch, getState) => {
        const page = localStorage.getItem("page")
        const state = getState();
        const projectId = state.project.Selected.id
        const document = state.renameModal.document;
        const loggedUser = state.loggedUser;
        const renameParams = {
            userId: loggedUser.data.id,
            updatedName,
            projectId,
            force,
            ...page? {page}: {page: null}
        };
      
        dispatch({ type: "SET_SCREEN_LOADER", Loading: true });
       
        return renameDocument(renameParams, document)
            .then( response => {
                localStorage.removeItem("page")
                dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                return response;
            })
    }
}
